import { Translations } from '@domain/admission';

export interface EditFieldModalLabels {
  title?: string;
  saveButton?: string;
  cancelButton?: string;
}

export interface EditFieldModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: Translations) => void;
  defaultValue: Translations;
  isEditDisabled?: boolean;
  labels?: EditFieldModalLabels;
}

export interface Form {
  name: Translations;
  nameLanguage: string;
}

export const OFFER_NAME_MAX_LENGTH = 100;
